import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.PublicPayPalPaymentPage.title',
    defaultMessage: 'Complete your payment for order #{orderId} {orderName}',
  },
  subtitle: {
    id: 'containers.PublicPayPalPaymentPage.subtitle',
    defaultMessage: "Click the button below to securely process your payment through PayPal.\nClick <a>here</a> to download a copy of your invoice.",
  },
  titlePayed: {
    id: 'containers.PublicPayPalPaymentPage.titlePayed',
    defaultMessage: 'Payment successful for order #{orderId} {orderName}',
  },
  subtitlePayed: {
    id: 'containers.PublicPayPalPaymentPage.subtitlePayed',
    defaultMessage: "We have received your payment, and your files will be released shortly.\nClick <a>here</a> to download your invoice.",
  },
  instructions: {
    id: 'containers.PublicPayPalPaymentPage.instructions',
    defaultMessage: "You will be redirected to PayPal, to complete the payment.",
  },
  pay: {
    id: 'containers.PublicPayPalPaymentPage.pay',
    defaultMessage: "Pay with PayPal",
  }
})
